import React from 'react';

import Urls from '../../../config/index';
import { Link } from 'react-router-dom';
import { message, Table, Tabs, Popconfirm, Button, Modal, Form, Pagination, Row } from 'antd';
import Serach from '../../utils/serach';
import Add from '../../utils/add';
import EditForm from '../../utils/edit';
import Head from '../../utils/head';
import request from '../../utils/request';
import { paramsEncode } from '../../utils/index';
const FormItem = Form.Item;

let getBrowserUrl = Urls.BrowserUrl.list;
let modify = Urls.BrowserUrl.modify;
let find = Urls.BrowserUrl.selectById;

export default class extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            total: 0,
            list: [],
            serach: {
                page: 1,
                pageSize: 10
            },
        };
        this.onChange = this.onChange.bind(this);
        this.handleRefresh = this.handleRefresh.bind(this);
    }

    componentWillMount() {
        this.getList(getBrowserUrl + paramsEncode(this.state.serach));
    }

    getList(url) {
        (async (url) => {
            try {
                let response = await request(url);
                this.setState(Object.assign(this.state, response));//total,list
            } catch (e) {
                alert(e.message)
            }
        })(url)
    }

    confirm(record) {
        let url = Urls.BrowserUrl.delete;
        (async (url) => {
            try {
                let response = await request(url, 'delete', record);
                message.success('删除成功');
                this.handleRefresh();//删除完成重新刷新网页
            } catch (e) {
                console.log(e);
                message.error('删除失败');
            }
        })(url);
    }

    onChange(current, pageSize) {
        let _serach = Object.assign(this.state.serach, { page: current, pageSize: pageSize });
        this.setState(Object.assign(this.state, { serach: _serach }));
        this.getList(getBrowserUrl + paramsEncode(this.state.serach));
    }

    serach(serach) {
        //记录搜索文本
        let _serach = Object.assign(this.state.serach, serach, { page: 1 });//page = 1
        this.setState(Object.assign(this.state, { serach: _serach }));
        (async (url) => {
            try {
                let response = await request(url);
                this.state.list = response.list;
                this.setState(Object.assign(this.state, response))
            } catch (e) {
                console.log(e);
                message.error('查询失败');
            }
        })(getBrowserUrl + paramsEncode(this.state.serach));
    }

    handleRefresh() {
        let _serach = Object.assign(this.state.serach, { page: 1 });
        this.setState(Object.assign(this.state, { serach: _serach }));
        this.getList(getBrowserUrl + paramsEncode(this.state.serach));
    }

    render() {
        let metadata = [{
            type: 'Input',
            placeholder: '浏览器',
            addonBefore: '名称',
            field: 'name'
        }];
        let addMetas = [{
            type: 'Input',
            placeholder: '名称',
            label: '名称',
            isRequired: true,
            field: 'name'
        }, {
            type: 'Input',
            placeholder: '起始占比',
            label: '起始占比',
            isRequired: true,
            field: 'begin'
        }, {
            type: 'Input',
            placeholder: '结束占比',
            label: '结束占比',
            isRequired: true,
            field: 'end'
        }, {
            type: 'Input',
            placeholder: '类型',
            label: '类型',
            isRequired: true,
            field: 'type'
        }]
        const columns = [{
            title: '名称',
            dataIndex: 'name',
            key: 'name',
        }, {
            title: '占比',
            dataIndex: '',
            render: record => {
                return record.end - record.begin;
            }
        }, {
            title: '操作',
            key: 'action',
            render: record => (
                <span>
                    <EditForm metadata={addMetas} url={modify} find={find + '' + record._id} handleRefresh={this.handleRefresh} />
                    <span className="ant-divider" />
                    <Popconfirm title="是否删除?" onConfirm={this.confirm.bind(this, record)}>
                        <a href="#">删除</a>
                    </Popconfirm>
                </span >
            )
        }];
        return (
            <div >
                <h2>浏览器列表</h2>
                <Row className="searchRow">
                    <Head serachMeta={metadata} addMeta={addMetas} addUrl={modify} handleRefresh={this.handleRefresh} handleSerach={this.serach.bind(this)} />
                </Row>
                <Table columns={columns} dataSource={this.state.list} pagination={false} bordered rowKey="_id"/>
                <Pagination
                    showQuickJumper
                    showSizeChanger
                    current={this.state.serach.page}
                    total={this.state.total}
                    className='ant-table-pagination'
                    onChange={this.onChange}
                    onShowSizeChange={this.onChange}
                />
            </div>
        );

    }

}




// WEBPACK FOOTER //
// ./components/sider/browser.js